export const ViewsEnum = {
    Welcome: 'welcome',
    Loading: 'loading',
    Goodbay: 'goodbay',
    Survey: 'survey',
    Error: 'error'
}